/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { BoxProps, Typography, styled } from "@mui/material";
import { FC } from "react";
import { DisplayItemNode } from "./DisplayItemNode";

export interface DisplayItemProps {
  /** Title */
  title: string;
  /** Value */
  value: string;
  boxProps?: BoxProps;
}

export const DisplayItemValue = styled(Typography)(({ theme }) => ({
  lineHeight: 1,
  marginTop: "-0.3rem",
  paddingLeft: "1rem",
  paddingBottom: "0.3rem",
  wordBreak: "break-word",
}));

/**
 * Component of item display
 * @param {Props} param0 Properties
 * @return {FC} Component
 */
export const DisplayItem: FC<DisplayItemProps> = ({
  title,
  value,
  boxProps,
}) => {
  return (
    <DisplayItemNode title={title} {...boxProps}>
      <Typography variant="h6">{value}</Typography>
    </DisplayItemNode>
  );
};
